import { useState, useEffect } from 'react';
import { useServiceWithAuth } from '@/hooks/useServiceWithAuth';
import { GroupsService, type PatientGroupAuditLog } from '@/services/features/GroupsService';
import { useErrorHandler } from '@/hooks/useErrorHandler';

export const usePatientGroupAuditLog = (patientGroupId: number | null) => {
  const service = useServiceWithAuth(GroupsService);
  const { handleError } = useErrorHandler();
  const [auditLogs, setAuditLogs] = useState<PatientGroupAuditLog[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAuditLogs = async () => {
      if (!patientGroupId) {
        setAuditLogs([]);
        return;
      }

      setLoading(true);
      try {
        const result = await service.getPatientGroupAuditLog(patientGroupId);
        
        if (result.success && result.data) {
          setAuditLogs(result.data.pep_patient_group_audit_log || []);
        } else {
          handleError(result.errors?.[0] || 'Failed to fetch audit logs');
          setAuditLogs([]);
        }
      } catch (err) {
        handleError(err, 'Error fetching audit logs');
        setAuditLogs([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAuditLogs();
  }, [patientGroupId]);

  return { auditLogs, loading };
};
